import React from "react";
import { useState } from "react";
import { TextInput } from "../../../shared/form/FormInput";
import { Validators } from "../../../shared/utils/Validators";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { RocketIcon } from "../../../shared/icons/Icons";

import { Alert, Button, Form, Spinner } from "react-bootstrap";
import { postApi } from "../../../shared/services/apiHelper";
import { registerUser } from "../../../shared/settings/apiConfig";
import { APP_LOGO_PATH } from '../../../shared/settings/config';

import './SignIn.scss';

export default function SignUp(props) {

    const [state, setState] = useState({
        formControls: {
            first_name: { value: '', valid: false, error: '', validators: [Validators.required()] },
            last_name: { value: '', valid: false, error: '', validators: [Validators.required()] },
            name: { value: '', valid: false, error: '', validators: [Validators.required()] },
            email: { value: '', valid: false, error: '', validators: [Validators.required(), Validators.email()] },
            mobile: { value: '', valid: false, error: '', validators: [Validators.required(), Validators.phoneNumberValid()] },
            password: { value: '', valid: false, error: '', validators: [Validators.required()] }
        },
        formValid: false
    })
    const [formLoading, setFormLoading] = useState(false);
    const [serverError, setServerError] = useState('');
    const [width, setwidth] = useState();

    useEffect(() => {
        window.addEventListener('resize', ()=>{
            setwidth(window.innerWidth)
        });
    
      return () => {
        
      }
    }, [])
    
    const onInputChange = (controlName, event) => {
        let data = {...state};
        data["formControls"][controlName] = Validators.validateFormControl(state.formControls[controlName], event.target.value);
        data["formValid"] = Validators.validateForm( data["formControls"]);
        setState(data);
    }

    const onSignUp = () => {
        setServerError('');

        // Re-validate all form controls before submitting
        let data = { ...state };
        let formValid = true;
        const controlKeys = Object.keys(data.formControls);
        controlKeys.forEach(key => {
            const control = data.formControls[key];
            data.formControls[key] = Validators.validateFormControl(control, control.value);
            if (!data.formControls[key].valid) {
                formValid = false;
            }
        });
        data.formValid = formValid;
        setState(data);

        if (!formValid) {
            setFormLoading(false);
            return;
        }

        setFormLoading(true);
       
        const payload = {
            "first_name": state.formControls.first_name.value,
            "last_name": state.formControls.last_name.value,
            "name": state.formControls.name.value,
            "email": state.formControls.email.value,
            "mobile": state.formControls.mobile.value,
            "password": state.formControls.password.value,
            "is_active": true,
            "is_deleted": false,
        };
        postApi(registerUser, payload).then(response => {
            setFormLoading(false);
            props.history.push('/sign-in');
        }).catch(error => {
            setFormLoading(false);

            const errorData = error.response?.data;
            let errMsg = 'An error occurred during registration. Please try again.';

            if (errorData?.detail) {
                if (Array.isArray(errorData.detail)) {
                    // Pydantic field validation errors (422)
                    const fieldErrors = {};
                    const msgs = errorData.detail.map(err => {
                        // Map the field name from the error location
                        const fieldName = err.loc?.[1];
                        if (fieldName && data.formControls[fieldName]) {
                            fieldErrors[fieldName] = err.msg;
                        }
                        return err.msg;
                    });
                    
                    // Update form controls with field-level errors from server
                    const fieldErrorKeys = Object.keys(fieldErrors);
                    if (fieldErrorKeys.length > 0) {
                        let updatedData = { ...state };
                        fieldErrorKeys.forEach(key => {
                            updatedData.formControls[key] = {
                                ...updatedData.formControls[key],
                                valid: false,
                                error: fieldErrors[key]
                            };
                        });
                        updatedData.formValid = Validators.validateForm(updatedData.formControls);
                        setState(updatedData);
                    }

                    errMsg = msgs.join('. ');
                } else if (typeof errorData.detail === 'string') {
                    // Business logic errors (400/500)
                    errMsg = errorData.detail;
                }
            }

            setServerError(errMsg);
        });
    }

    return (
        <div className="signin w-100">
            <div className='scontainer'>
                <div className='sigincontent mt-5 mb-5'>
                    <div className='d-flex align-items-center'>
                            <img className="loader-img" src={APP_LOGO_PATH} alt="Logo" />
                        </div>
                        <div class="shadow-lg">
                            <div className='d-flex align-items-center flex-column gap-2'>
                                <div className='summary-icon-orange p-3 rounded'><RocketIcon color="#FFF" /></div>
                                <span className='welcome-text text-3l font-weight-bold'>Create an account</span>
                                <span className='signin-text text-muted text-l'>
                                    Start estimating construction costs with AI
                                </span>
                            </div>
                            {serverError && (
                                <Alert variant="danger" onClose={() => setServerError('')} dismissible className="mt-3">
                                    {serverError}
                                </Alert>
                            )}
                            <Form className="w-100 d-flex flex-column justify-content-center my-1 mt-5 gap-3">
                                <TextInput type={'text'} name={'first_name'} label={'First Name'} placeholder={'First Name'}
                                    value={state.formControls.first_name.value} error={state.formControls.first_name.error} onChange={(event) => { onInputChange('first_name', event); }} isMandatory />

                                <TextInput type={'text'} name={'last_name'} label={'Last Name'} placeholder={'Last Name'}
                                    value={state.formControls.last_name.value} error={state.formControls.last_name.error} onChange={(event) => { onInputChange('last_name', event); }} isMandatory />

                                <TextInput type={'text'} name={'name'} label={'Name'} placeholder={'Name'}
                                    value={state.formControls.name.value} error={state.formControls.name.error} onChange={(event) => { onInputChange('name', event); }} isMandatory />

                                <TextInput type={'text'} name={'email'} label={'Email'} placeholder={'Email'}
                                    value={state.formControls.email.value} error={state.formControls.email.error} onChange={(event) => { onInputChange('email', event); }} isMandatory />

                                <TextInput type={'text'} name={'mobile'} label={'Mobile'} placeholder={'Mobile'}
                                    value={state.formControls.mobile.value} error={state.formControls.mobile.error} onChange={(event) => { onInputChange('mobile', event); }} isMandatory />

                                <TextInput type={'text'} name={'password'} label={'Password'} placeholder={'Password'}
                                    value={state.formControls.password.value} error={state.formControls.password.error} onChange={(event) => { onInputChange('password', event); }} isMandatory />
                                
                                
                                <Button className="primary-gradient-btn sign-btn" onClick={onSignUp} disabled={!state.formValid}>Create Account {formLoading ? <Spinner className='ms-2' as="span" animation="border" role="status" aria-hidden="true" /> : ''}</Button>

                                <p className="py-2 ">Already have an account? <Link to="/sign-in" ><span className='text-primary' style={{fontWeight:"bolder"}}> Log in</span></Link></p>     
                            </Form>
                        </div>
                </div>
            </div>
        </div>
    )
}